"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "userEditCtrl",
    function (
      $scope,
      $rootScope,
      $window,
      $state,
      $http,
      $filter,
      permissionService,
      MessageService,
      model,
      language,
      groups,
      salesTeam,
      subAreas,
      User,
      Auth,
      Internal,
      states,
      managersColor,
      Customer,
      customersOwn,
      approvers
    ) {
      var vm = this;

      vm.subAreas = subAreas;
      vm.permissions = permissionService;

      vm.projectModule = config.projectModule;

      if (!vm.permissions.isAdminAccessAuthorized()) return;

      var $translate = $filter("translate");

      vm.model = model;
      vm.enumLanguage = language;
      vm.customersOwn = customersOwn;
      vm.model.imageAvatar =
        vm.model.imageAvatar || $scope.globalConfig.defaultImage;

      vm.groupsActions = groups.filter(
        (x) => x.moduleId == window.enumerators.modules.Acoes
      );
      vm.groupsColors = groups.filter(
        (x) => x.moduleId == window.enumerators.modules.Cores
      );
      vm.groups = window.enumerators.enumGroupsColorsRequests;

      vm.groupsBonusesAndSponsorship = groups.filter((x) => x.moduleId == 3);

      vm.managersColor = managersColor;
      vm.approvers = approvers;
      vm.states = states;
      vm.tab = vm.projectModule == 'Colors' ? "cores" : "acoes";

      vm.flow_tradeCoordinators = [];
      if (vm.projectModule == 'SWFlow') {
        Internal.usersListIdsByModuleAndGroup({ moduleId: 1, groupId: window.enumerators.enumGroupsFlow.CoordenadorTrade }).$promise.then(function (result) {
          vm.flow_tradeCoordinators = result;
        });
      }

      // Autocomplete de inserção de Lojas

      vm.model.customers = vm.model.customers || [];

      vm.getCustomers = function (val) {
        return Customer.customersAutocomplete({ keyword: val }).$promise;
      };

      vm.addCustomer = function (selectedCustomer) {
        if (!selectedCustomer) return;

        var customerAlreadyAdded = vm.model.customers && vm.model.customers.find((customer) => customer.customerId === selectedCustomer.id)
        if (vm.model.customers && vm.model.customers.indexOf(selectedCustomer) === -1 && !customerAlreadyAdded) {
          vm.model.customers.push({
            customerId: selectedCustomer.id,
            code: selectedCustomer.code,
            cnpjCpf: selectedCustomer.cnpjMasked,
            companyName: selectedCustomer.name,
            tradingName: selectedCustomer.manager,
          });
        }
        vm.selectedCustomer = '';
      };

      vm.removeCustomer = function (index) {
        vm.model.customers.splice(index, 1);
      };

      // Autocomplete de inserção de SubÁreas

      vm.model.bonusesAndSponsorshipsSubAreas = vm.model.bonusesAndSponsorshipsSubAreas || [];

      vm.addArea = function (selectedArea) {
        if (!selectedArea) return;

        var areaAlreadyAdded = vm.model.bonusesAndSponsorshipsSubAreas && vm.model.bonusesAndSponsorshipsSubAreas.includes(selectedArea.bonusesAndSponsorshipsRequestSubAreaId);

        if (!areaAlreadyAdded) {
          vm.model.bonusesAndSponsorshipsSubAreas.push(selectedArea.bonusesAndSponsorshipsRequestSubAreaId);
        }
        vm.selectedArea = null;
      };

      vm.removeArea = function (index) {
        vm.model.bonusesAndSponsorshipsSubAreas.splice(index, 1);
      };

      vm.getAreaName = function (areaId) {
        var area = vm.subAreas.find(function (option) {
          return option.bonusesAndSponsorshipsRequestSubAreaId === areaId;
        });
        return area ? area.name : 'Nome não encontrado';
      };


      // Se não tiver gerente sera como array vazio
      vm.model.managerColorIds = vm.model.managerColorIds;
      if (!vm.model.managerColorIds) {
        vm.model.managerColorIds = [];
      } else {
        // Se tiver manager/aprovador e for do designer seta no campo approverId
        if (vm.model.groups.indexOf(vm.groups.Designer) !== -1) {
          if (vm.model.managerColorIds.length > 0) {
            vm.model.approverId = vm.model.managerColorIds[0];
          }
        }
      }

      vm.salesTeam = salesTeam;
      vm.resetPasswordEmail = vm.model.email;

      angular.extend($scope.$parent.vm, {
        title: "users.settings.title",
        insertUrl: null,
      });

      $rootScope.laddaLoading = false;

      /* 
          Funções de tela
      */

      vm.flow_isGerenteRegional = function () {
        return (vm.model.groups && vm.model.groups.indexOf(window.enumerators.enumGroupsFlow.GerenciaRegional) !== -1);
      }

      vm.reject = function () {
        User.delete(
          { id: vm.model.userId },
          function () {
            $state.go("main.user");
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.save = function () {
        if (!vm.model.groups || !vm.model.groups.length) {
          MessageService.alertError("Selecione ao menos um grupo.");
          return;
        }

        var isDesigner = vm.model.groups.indexOf(vm.groups.Designer) !== -1;
        var isGerenteRegional = vm.model.groups.indexOf(vm.groups.GerenteRegional) !== -1;


        if (vm.projectModule == "Colors") {
          var _isSaoPaulo = vm.verifySaoPaulo();

          if (
            isDesigner || isGerenteRegional
          ) {
            if (!vm.model.stateId || !vm.model.stateId.length) {
              MessageService.alertError(
                "Selecione ao menos um estado para o usuário."
              );
              return;
            }

            if (_isSaoPaulo && (!(vm.model.isSPCapitol ?? false) && !(vm.model.isSPNotCapitol ?? false))) {
              MessageService.alertError(
                "Ao Selecionar o Estado de São Paulo, você deve determinar se atende ao menos Capital ou Interior."
              );
              return;
            }
          } else {
            vm.model.stateId = [];
            vm.model.approverId = null;
          }
        }

        if (
          vm.model.groups.indexOf(vm.groups.VendedorBalcao) !== -1 &&
          vm.model.isSalesTeam
        ) {
          MessageService.alertError(
            "Vendedor Balcão não pode fazer parte do time de vendas de Ações."
          );
          return;
        }

        if (
          vm.model.groups.indexOf(vm.groups.GerenteNacional) !== -1 &&
          vm.model.groups.length > 1
        ) {
          MessageService.alertError(
            "Gerente Nacional não pode fazer parte de outros grupos."
          );
          return;
        }

        $rootScope.laddaLoading = true;

        if (vm.model.approverId) {
          vm.model.managerUserId = vm.model.approverId;
        } else if (vm.projectModule == "Colors" && vm.model.groups.indexOf(vm.groups.Designer) !== -1) {
          vm.model.managerUserId = null;
        }

        if (vm.model.imageAvatar)
          vm.model.imageAvatar = vm.model.imageAvatar.split("/").pop();

        vm.model.managerColorIds = [];
        if (vm.managerOneId) {
          vm.model.managerColorIds.push(vm.managerOneId);
        }
        if (vm.managerTwoId) {
          vm.model.managerColorIds.push(vm.managerTwoId);
        }

        if (!vm.flow_isGerenteRegional()) {
          vm.model.tradeCoordinatorUserId = null;
        }

        vm.model.projectModule = config.projectModule;

        if (!vm.model.userId) {
          User.insert(
            vm.model,
            function () {
              $state.go("main.user");
            },
            function (response) {
              MessageService.alertError(response.data);
            }
          );
        } else {
          User.update(
            vm.model,
            function () {
              $state.go("main.user");
            },
            function (response) {
              MessageService.alertError(response.data);
            }
          );
        }
      };

      vm.verifyDesigner = function () {
        if (vm.model.groups) {
          if (vm.model.groups.indexOf(vm.groups.Designer) !== -1) {
            return true;
          }
        }

        return false;
      };

      vm.verifyRegionalManager = function () {
        if (vm.model.groups) {
          if (vm.model.groups.indexOf(vm.groups.GerenteRegional) !== -1) {
            return true;
          }
        }
        return false;
      };

      vm.verifyStatesList = function () {
        if (vm.model.groups) {
          if (vm.model.groups.indexOf(vm.groups.GerenteRegional) !== -1 || vm.model.groups.indexOf(vm.groups.Designer) !== -1) {
            return true;
          }
        }

        return false;
      }

      vm.verifySaoPaulo = function () {
        if (vm.model.stateId && vm.model.stateId.length && vm.model.stateId.indexOf(25) !== -1) {

          vm.model.isSPCapitol = vm.model.isSPCapitol ?? true;
          vm.model.isSPNotCapitol = vm.model.isSPNotCapitol ?? true;

          return true;
        }

        vm.model.isSPCapitol = null;
        vm.model.isSPNotCapitol = null;

        return false;
      }

      vm.verifySalesman = function () {
        if (vm.projectModule == 'Colors' && vm.model.groups) {
          if (vm.model.groups.indexOf(vm.groups.VendedorBalcao) !== -1) {
            return true;
          }
        }
        return false;
      };

      vm.verifyIsColorCustomer = function () {
        if (vm.model.groups) {
          // Se grupo for vendedor e for da Rede SW mostra o gerente para selecionar
          if (
            vm.model.groups.indexOf(vm.groups.VendedorBalcao) !== -1) {
            return true;
          }
        }
        return false;
      };

      vm.resetPassword = function () {
        if (!vm.model.userId) return;

        MessageService.confirm(
          function () {
            $rootScope.laddaLoading = true;

            Auth.passwordResetRandom(
              {
                userId: vm.model.userId,
                email: vm.resetPasswordEmail,
                projectModule: config.projectModule,
              },
              function (response) {
                MessageService.alertInfo(
                  "Senha resetada com sucesso! O usuário receberá um email com a nova senha.",
                  "Reset de senha"
                );

                $rootScope.laddaLoading = false;
              },
              function (response) {
                MessageService.alertError(response.data);

                $rootScope.laddaLoading = false;
              }
            );
          },
          "Confirmação",
          "Deseja realmente resetar a senha do usuário? Uma nova senha será enviada para o email:<br />" +
          vm.resetPasswordEmail
        );
      };

      vm.changeTab = function (status) {
        switch (status) {
          case "acoes":
            vm.tab = "acoes";
            break;
          case "cores":
            vm.tab = "cores";
            break;
          case "bonificacoes":
            vm.tab = "bonificacoes";
            break;
          default:
            break;
        }
      };

      vm.managerOne = function () {
        if (vm.managerOneId && vm.managerOneId == vm.managerTwoId) {
          MessageService.alertError("Gerente já incluído");
          vm.managerTwoId = null;
          vm.fillManagersColors();
        }
      };

      vm.managerTwo = function () {
        if (vm.managerTwoId && vm.managerTwoId == vm.managerOneId) {
          MessageService.alertError("Gerente já incluído");
          vm.managerTwoId = null;
          vm.fillManagersColors();
        }
      };

      vm.fillManagersColors = function () {
        // Só preenche info abaixo quando tiver aprovador, pois aprovador é só do designer
        if (
          vm.model.managerColorIds &&
          vm.model.managerColorIds.length >= 1 &&
          !vm.model.approverId
        ) {
          vm.managerOneId = vm.model.managerColorIds[0];

          if (vm.model.managerColorIds[1]) {
            vm.managerTwoId = vm.model.managerColorIds[1];
          }
        }
      };

      vm.fillManagersColors();
    }
  );
